import React from 'react';

import { Logo } from '..';

const Section = ({
  children,
  hasLogo,
  noSpacing,
  backgroundImage,
  backgroundVideo,
  backgroundVideoMobile,
  reference,
  contentReference,
  isFixed,
  zIndex,
  logo,
  isVisible,
  content,
  bgStyles,
}) => {
  const styles = {
    ...(!backgroundVideo && {
      backgroundImage:
        backgroundImage &&
        `${bgStyles ? `${bgStyles}, ` : ''}url(${backgroundImage}`,
    }),

    zIndex,
  };

  return (
    <section
      style={styles}
      id={(reference || {}).id}
      ref={(reference || {}).ref}
      className="section"
    >
      {!noSpacing && (
        <div
          className={`section__spacing ${
            isFixed ? 'section__spacing--no-mobile' : ''
          }`}
        >
          {hasLogo && <Logo logo={logo} />}
          {!isFixed && !backgroundVideo && !backgroundVideoMobile && (
            <img
              src={backgroundImage}
              className="section__mobile-image"
              alt="Background"
              loading="lazy"
            />
          )}
          {(backgroundVideo || backgroundVideoMobile) && (
            <>
              {backgroundVideo && (
                <video
                  src={backgroundVideo}
                  className="section__video section__video--desktop"
                  autoPlay
                  loop
                  muted
                  playsInline
                />
              )}
              {backgroundVideoMobile && (
                <video
                  src={backgroundVideoMobile}
                  className="section__video section__video--mobile"
                  autoPlay
                  loop
                  muted
                  playsInline
                />
              )}
            </>
          )}
        </div>
      )}
      <div
        className={`section__content ${isFixed ? 'is-fixed' : ''} ${
          !isVisible && isFixed ? 'hidden' : ''
        }`}
        id={(contentReference || {}).id}
        ref={(contentReference || {}).ref}
      >
        {content}
        <div className="container">{children}</div>
      </div>
    </section>
  );
};

export default Section;
